import { SVGFC } from '@repo/toolkit/types'

const CastleIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15899_118827)">
        <path
          d="M7.75023 5.93329V4.70886C7.75023 3.91833 7.11364 3.28174 6.32311 3.28174H4.70866C3.91813 3.28174 3.28154 3.91833 3.28154 4.70886V6.96655V7.83612V8.60846C3.28154 9.18092 3.61543 9.64172 4.40596 9.64172H19.6385C20.429 9.64172 20.719 9.18092 20.719 8.60846V6.96655V4.70886C20.719 3.91833 20.0824 3.28174 19.2919 3.28174H17.6775C16.8869 3.28174 16.2504 3.91833 16.2504 4.70886V5.93329M15.3136 5.93329H14.2344V4.70886C14.2344 3.91833 13.5983 3.28174 12.8078 3.28174H11.1928C10.4023 3.28174 9.76622 3.91833 9.76622 4.70886V5.93329H8.71314M6.33843 10.5536L3.36009 18.684C3.07035 19.8409 3.59853 20.7187 4.32909 20.7187H10.7039H13.2945H19.6693C20.3999 20.7187 20.928 19.8409 20.6383 18.684L17.6772 10.6007"
          stroke={color}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0928 19.6443V17.4251C16.0928 14.9512 14.4396 12.962 11.9971 12.8845C11.9483 12.8829 11.9044 12.8834 11.8549 12.8834C9.33141 12.8834 7.90527 14.9017 7.90527 17.4251V19.6109"
          stroke={color}
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M11.999 14.4673V20.7188V14.4673Z" fill={color} />
        <path
          d="M11.999 14.4673V20.7188"
          stroke={color}
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9227 18.0475C14.3053 18.0475 14.6154 17.7374 14.6154 17.3548C14.6154 16.9723 14.3053 16.6621 13.9227 16.6621C13.5401 16.6621 13.23 16.9723 13.23 17.3548C13.23 17.7374 13.5401 18.0475 13.9227 18.0475Z"
          stroke={color}
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15899_118827">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CastleIcon
